<template>
  <div class="catalogue" id="sideBarRippleWrap">
    <div class="title">gategories</div>
    <div class="sep"></div>
    <ul class="fadeOutList">
      <li
        class="ripple"
        @click="getArticle()"
        :class="{ active: nowCategorie === '' }"
      >
        <p></p>
        <i>></i>
        <span class="info">全部</span>
        <span class="number">{{ allLength }}</span>
        <div class="rippleWrap">
          <span></span>
        </div>
      </li>
      <li
        class="ripple"
        v-for="(item, index) in categories"
        :key="index"
        @click="getArticle(item.col)"
        v-show="index <= 10 || isMore"
        :class="{ active: nowCategorie === item.col }"
      >
        <p></p>
        <i>></i>
        <span class="info">{{ item.col }}</span>
        <span class="number">{{ item._count }}</span>
        <div class="rippleWrap">
          <span></span>
        </div>
      </li>
    </ul>
    <div class="more" v-if="categories.length > 10 && !isMore" @click="getMore">
      <span>查看更多</span>
      <i>></i>
    </div>
  </div>
</template>

<script>
import { ListfadeOut, ripple } from "@/assets/script/common";
export default {
  data() {
    return {
      isMore: false
    };
  },
  props: {
    categories: {
      type: Array,
      default: []
    },
    nowCategorie: {
      type: String
    }
  },
  computed: {
    allLength() {
      let totalNum = 0;
      this.categories.forEach(function(item) {
        totalNum += item._count;
      }, this);
      return totalNum;
    }
  },
  mounted() {
    this.$nextTick(() => {
      ListfadeOut();
      ripple("sideBarRippleWrap");
    });
  },
  watch: {
    categories() {
      this.$nextTick(() => {
        ListfadeOut();
        ripple("sideBarRippleWrap");
      });
    }
  },
  methods: {
    getArticle(col) {
      // 点击获取对应分类的文章
      this.$emit("getColumnArticle", col ? col : "");
    },
    getMore() {
      this.isMore = true;
    }
  }
};
</script>

<style lang="less">
@import "../../../assets/style/common.less";
@m26a69a: #26a69a;
@mdedede: #dedede;
@m383838: #383838;
.catalogue {
  padding-left: 60px;
  .title {
    font-size: 16px;
    line-height: 32px;
    color: #aaaaaa;
    text-transform: uppercase;
  }
  .sep {
    width: 100%;
    height: 1px;
    margin: 6px 0 10px;
    background-color: @mdedede;
  }
  ul {
    .rippleMixin(0px, 32px, rgba(255, 255, 255, 0.4), 400, catalogue);
    font-size: 0;
    max-height: 300px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-track-piece {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb:vertical {
      height: 5px;
      background-color: rgba(125, 125, 125, 0.7);
      -webkit-border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb:horizontal {
      width: 5px;
      background-color: rgba(125, 125, 125, 0.7);
      -webkit-border-radius: 6px;
    }
    li {
      width: 100%;
      font-size: 14px;
      line-height: 32px;
      color: @m383838;
      p {
        position: absolute;
        height: 32px;
        top: 0;
        left: 0;
        width: 100%;
        background: #4db6ac;
        opacity: 0;
        filter: alpha(opacity=0);
      }
      i {
        position: absolute;
        font-style: normal;
        font-family: sans-serif;
        padding: 0 5px 0 10px;
      }
      .info {
        position: absolute;
        left: 22px;
      }
      .number {
        position: absolute;
        top: 7px;
        right: 0;
        padding: 0 8px;
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        background-color: #4db6ac;
        color: #fff;
        border-radius: 4px;
      }
      &.active {
        background: #4db6ac;
        i {
          color: #fff;
        }
        .info {
          color: #fff;
        }
      }
    }
  }
  .more {
    line-height: 30px;
    text-align: center;
    border-radius: 2px;
    border: 1px solid #dcdcdc;
    font-size: 14px;
    color: #787878;
    background-color: #f7f7f7;
    margin-top: 15px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// catalogue.vue?41814670